import { useEffect, useState } from "react";

import {
    Badge,
    Button,
    Card,
    CardBody,
    Spinner,
    Table
} from "reactstrap";

import MemberManagementModal from "./MemberManagementModal";
import { getMembers } from "../Services/GroupMemberService";
import "./MemberList.css";

interface Props {
    groupId: string;
}

const MembersList = ({ groupId }: Props) => {

    const [loading, setLoading] =
        useState(true);

    const [members, setMembers] =
        useState<any[]>([]);

    const [selectedMember, setSelectedMember] =
        useState<any>(null);

    const [modalOpen, setModalOpen] =
        useState(false);

    useEffect(() => {

        loadMembers();
// eslint-disable-next-line
    }, [groupId]);

    const loadMembers = async () => {

        setLoading(true);

        try {

            const response =
                await getMembers(groupId);

            setMembers(response);

        }
        catch (error) {

            console.error(error);

        }
        finally {

            setLoading(false);

        }

    };

    const removeMember = async (groupMemberId: string) => {

        if (!window.confirm("Remove this member?"))
            return;

        await removeMember(groupMemberId);

        loadMembers();

    };

    if (loading)
        return (

            <div className="text-center py-5">

                <Spinner />

            </div>

        );

    return (

        <>

            <Card className="shadow-sm">

               <CardBody>
  <div className="d-flex justify-content-between align-items-center mb-4 flex-wrap">
    <h4 className="mb-2 mb-md-0">Members</h4>

    <Badge color="primary" pill>
      {members.length} Members
    </Badge>
  </div>

  {/* Desktop Table */}
  <div className="desktop-table">
    <Table hover responsive bordered className="align-middle">
      <thead className="table-primary">
        <tr>
          <th>Name</th>
          <th>Email</th>
          <th>Role</th>
          <th>Blocked</th>
          <th>Muted</th>
          <th>Joined</th>
          <th >Actions</th>
        </tr>
      </thead>

      <tbody>
        {members.map((member) => (
          <tr key={member.groupMemberId}>
            <td>{member.userName}</td>

            <td>{member.email}</td>

            <td>{member.role}</td>

            <td>
              <Badge color={member.isBlocked ? "danger" : "success"}>
                {member.isBlocked ? "Yes" : "No"}
              </Badge>
            </td>

            <td>
              {member.isMuted ? (
                <>
                  <Badge color="warning">Yes</Badge>

                  {member.mutedUntil &&
                    member.mutedUntil !== "0001-01-01T00:00:00" && (
                      <div className="small text-muted mt-1">
                        Until:
                        <br />
                        {new Date(member.mutedUntil).toLocaleString()}
                      </div>
                    )}
                </>
              ) : (
                <Badge color="secondary">No</Badge>
              )}
            </td>

            <td>
              {new Date(member.joinedAt).toLocaleDateString()}
            </td>

            <td>
              <Button
                color="primary"
                size="sm"
                className="me-2"
                onClick={() => {
                  setSelectedMember(member);
                  setModalOpen(true);
                }}
              >
                Manage
              </Button>

              <Button
                color="danger"
                size="sm"
                onClick={() => removeMember(member.groupMemberId)}
              >
                Remove
              </Button>
            </td>
          </tr>
        ))}
      </tbody>
    </Table>
  </div>

  
</CardBody>



            </Card>

            {/* Mobile Cards */}
  <div className="mobile-members">
    {members.map((member) => (
      <Card
        key={member.groupMemberId}
        className="member-card shadow-sm mb-3 border-0"
      >
        <CardBody>

          <div className="d-flex justify-content-between align-items-center mb-3">
            <h6 className="mb-0 fw-bold text-primary">
              {member.userName}
            </h6>

            <Badge color="info">
              {member.role}
            </Badge>
          </div>

          <div className="member-row">
            <span>Email</span>
            <strong>{member.email}</strong>
          </div>

          <div className="member-row">
            <span>Blocked</span>

            <Badge color={member.isBlocked ? "danger" : "success"}>
              {member.isBlocked ? "Yes" : "No"}
            </Badge>
          </div>

          <div className="member-row">
            <span>Muted</span>

            {member.isMuted ? (
              <Badge color="warning">
                Yes
              </Badge>
            ) : (
              <Badge color="secondary">
                No
              </Badge>
            )}
          </div>

          {member.isMuted &&
            member.mutedUntil &&
            member.mutedUntil !== "0001-01-01T00:00:00" && (
              <div className="text-muted small mb-3">
                Muted Until:
                <br />
                {new Date(member.mutedUntil).toLocaleString()}
              </div>
            )}

          <div className="member-row">
            <span>Joined</span>

            <strong>
              {new Date(member.joinedAt).toLocaleDateString()}
            </strong>
          </div>

          <div className="d-grid gap-2 mt-3">
            <Button
              color="primary"
              onClick={() => {
                setSelectedMember(member);
                setModalOpen(true);
              }}
            >
              Manage
            </Button>

            <Button
              color="danger"
              onClick={() => removeMember(member.groupMemberId)}
            >
              Remove
            </Button>
          </div>

        </CardBody>
      </Card>
    ))}
  </div>

            <MemberManagementModal
                isOpen={modalOpen}
                toggle={() => setModalOpen(false)}
                member={selectedMember}
                reload={loadMembers}
            />

        </>

    );

};

export default MembersList;